import Vue from "vue";
import noty from "./noty.service";

export default {
  async getOperationsAwaitingAntiFraudAsync() {
    return (await Vue.http.get(`/api/payment-system/operations/awaiting-antifraud`)).data;
  },
  async applyAntiFraudActionAsync({ operationId, action, setDefault }) {
    const result = (await Vue.http.post(`/api/payment-system/operations/awaiting-antifraud/${operationId}/${action}?setDefault=${setDefault}`)).data;
    result.isSuccess ? noty.success(`${action} was successfull`) : noty.error(`Error occurred during ${action}`);
    return result;
  }
};



// WEBPACK FOOTER //
// ./src/services/paymentSystem.service.js